/**
 * Page
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import useTheme from 'containers/ThemeProvider/useTheme.js';
import socsLogo from 'images/socsText.png';
import { intlBreak } from 'utils/intlFunctions.jsx';
import messages from './messages.js';

const Wrapper = styled.div`
  @page {
    size: A4 portrait;
    margin: 11mm 17mm 0mm 17mm;
  }
  break-after: always !important;
  page-break-after: always !important;
  padding: 15px;
  @media screen {
    margin-top: 20px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
  @media print {
    display: flex;
    flex-direction: column; 
    justify-content: stretch;
    min-height: 240mm;
  }
  h2 {
    font-size: 1.2em;
    font-weight: 500;
  }
  h3 {
    font-size: 1em;
    font-weight: 600;
  }
  .def-label {
    display: inline-block;
    width: 10em;
    text-align: right;
    margin-right: 0.65rem;
  }
`;

const Header = styled.header`
  text-align: center;
  h1 {
    font-size: 2rem;
  }
  img {
    max-height: 100px;
  }
  margin-bottom: 3em;
`;

const Footer = styled.footer`
  text-align: center;
  width: 100%;
  img {
    max-height: 34px;
  }
  @media screen {
    margin-top: 5em;
  }
`;

function Page(props) {
  const { header, footer, greeting, children } = props;
  const theme = useTheme();
  const { logo, displayName } = theme;
  return (
    <Wrapper>
      {header && (
        <Header>
          {logo && <img src={logo} alt="logo" className="mb-3" />}
          <h1>{displayName}</h1>
        </Header>
      )}
      <div className="flex-grow-1">
        {children}
        {greeting && (
          <>
            <p className="mt-4"><FormattedMessage {...messages.greeting} /></p>
            <p>{displayName}</p>
          </>
        )}
      </div>
      {footer && (
        <Footer>
          <p><FormattedMessage {...messages.downloadApp} values={intlBreak} /></p>
          <img src={socsLogo} alt="Social Schools logo" />
        </Footer>
      )}
    </Wrapper>
  );
}

Page.propTypes = {
  header: PropTypes.bool,
  footer: PropTypes.bool,
  greeting: PropTypes.bool,
  children: PropTypes.node,
};

export default Page;
